<div class="btn-group m-t-10 dropdown">
	<a class="dropdown-toggle js-model-action clickable" type="button" data-toggle="dropdown">
		<span class="p-l-5"><i class="caret h-15"></i></span>
	</a>
	<ul class="dropdown-menu js-links" >{{{links}}}
	</ul>
</div>
